// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'secondary', 'secondary Fallback'","fontWeight":700,"fontStyle":"normal"},"className":"__className_e18755","variable":"__variable_e18755"};